/**
 * Semantic tones shared by badges, icon tiles, stat cards and callouts.
 * Map domain states (report status, risk level, priority…) to a tone — never to raw colours.
 */
export type Tone = 'neutral' | 'brand' | 'info' | 'success' | 'warning' | 'danger';

export const toneClasses: Record<Tone, { tile: string; text: string; solid: string; ring: string }> = {
    neutral: { tile: 'bg-muted text-secondary-foreground', text: 'text-secondary-foreground', solid: 'bg-muted-foreground', ring: 'border-border' },
    brand: { tile: 'bg-primary-subtle text-primary', text: 'text-primary', solid: 'bg-primary', ring: 'border-primary/30' },
    info: { tile: 'bg-info-subtle text-info', text: 'text-info', solid: 'bg-info', ring: 'border-info/30' },
    success: { tile: 'bg-success-subtle text-success', text: 'text-success', solid: 'bg-success', ring: 'border-success/30' },
    warning: { tile: 'bg-warning-subtle text-warning', text: 'text-warning', solid: 'bg-warning', ring: 'border-warning/30' },
    danger: { tile: 'bg-danger-subtle text-danger', text: 'text-danger', solid: 'bg-danger', ring: 'border-danger/30' },
};
